import React, { useState } from "react";
import { ShowAlert } from "../../../common/alert";

const EditComp = ({ setEditComponent, NoteId, editNotes, modifiedText, title, loading }) => {
   const [notetitle, setNotetitle] = useState(title);
   const [text, setText] = useState(modifiedText);
   const handleTitleChange = (event) => {
      setNotetitle(event.target.value);
   };
   const handleInputChange = (event) => {
      setText(event.target.value);
   };
   const handleSave = (NoteId, notetitle, text) => {
      if (notetitle?.trim()?.length === 0 || text?.trim()?.length === 0) {
         ShowAlert("Title or note cannot be empty!", "error");
         return;
      }
      if (title !== notetitle && modifiedText !== text) {
         editNotes({ id: NoteId, note: text, title: notetitle });
      } else if (title !== notetitle) {
         editNotes({ id: NoteId, title: notetitle });
      } else if (modifiedText !== text) {
         editNotes({ id: NoteId, note: text });
      }
   };

   return (
      <div className="edit-container-epic-main">
         <input
            style={{ width: "100%" }}
            value={notetitle}
            name="inputtitle"
            className={`edit-title-text custom-border-1x p-4`}
            onChange={handleTitleChange}
            placeholder="Note Title"
            autoComplete="off"
         />
         <textarea
            placeholder="To save your edits, add text to your note."
            rows="7"
            cols="50"
            name="text"
            value={text}
            className="edit-input scrollbar-notes overflow-auto edit-textarea-text mt-3 custom-border-1x"
            onChange={handleInputChange}
            required
         ></textarea>
         <div className="flex-center edit-button-container">
            <button
               disabled={loading}
               onClick={() => setEditComponent(false)}
               className="epic-cencle-button-container flex-center"
            >
               <div className="centle-text">Cancel</div>
            </button>
            <button
               disabled={loading}
               onClick={() => handleSave(NoteId, notetitle, text)}
               className={`flex-center ${text?.length > 2 ? "epic-blue-save-button" : "epic-gray-save-button"} `}
            >
               <div
                  className={` ${
                     text?.length < 2 ? "epic-gray-save-text" : loading ? "spinner-border text-light" : "save-text"
                  }`}
               >
                  {!loading && "Save"}
               </div>
            </button>
         </div>
      </div>
   );
};

export default EditComp;
